import React from "react";
import { TableCell, TableRow } from "@mui/material";
import { Alert } from "@mui/lab";

export default function DropDownContent(props) {
    const { children, span, error } = props;
    return (
        <>
            <TableRow sx={{ display: "none" }} />
            <TableRow sx={{ border: 0, height: "100px !important" }}>
                <TableCell />
                <TableCell colSpan={span}>
                    { error
                        ? (
                            <Alert
                                severity="error"
                                sx={{ maxWidth: "300px" }}
                            >
                                <b>Adresse bereits vorhanden</b>
                            </Alert>
                        )
                        : (
                            <Alert
                                severity="info"
                                sx={{ maxWidth: "300px" }}
                            >
                                {children}
                            </Alert>
                        )}
                </TableCell>
            </TableRow>
        </>
    );
}
